import styled from 'styled-components';
import Button from '../Button';

export const SideMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  padding: 20px 20px 90px 20px;
  height: 100%;
  overflow-y: scroll;
  position: relative;
`;

export const CatalogList = styled.ul`
  margin: 0px;
  padding: 0px;
  li:first-child {
    margin-top: 15px;
  }
`;

export const ErrorMsg = styled.p`
  color: red;
  text-align: center;
`;

export const AddCardButton = styled(Button).attrs({
  wrapperStyle: {
    width: '312px',
    position: 'fixed',
    bottom: '30px',
    left: '20px',
    fontWeight: '600',
  },
})``;

export const EmptyResults = styled.div`
  margin:2em;
  color:grey;
`;
